import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilsService } from '../../../shared/utils.service';

/**
 * Filter options for the account membership approvals list (SC-301).
 *
 * A dedicated dialog rather than an inline control in the list header. The status select was originally
 * placed inline, which made the Access Requests header noticeably taller than every other list in the
 * product because a mat-form-field is much taller than a button. Every other list puts its filters behind
 * a Filter button, so this follows that.
 */
@Component({
  selector: 'app-access-requests-filter',
  templateUrl: './access-requests-filter.component.html',
  styleUrls: ['./access-requests-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccessRequestsFilterComponent implements OnInit {
  filter_options: {
    status: string;
  } = {
    // Pending is the actionable queue, so it is the default view.
    status: 'pending'
  };

  statusOptions: { value: string; label: string }[] = [
    { value: 'pending', label: 'Pending' },
    { value: 'declined', label: 'Declined' },
    { value: 'approved', label: 'Approved' },
    { value: 'all', label: 'All' }
  ];

  constructor(
    public utils: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AccessRequestsFilterComponent>
  ) {
    // Default to the pending queue when the caller passes nothing.
    if (typeof this.data['status'] == 'undefined' || !this.data['status']) {
      this.data['status'] = 'pending';
    }
  }

  ngOnInit() {
    this.filter_options.status = this.data['status'];
  }

  /**
   * Reset to the default view and close.
   *
   * Clearing returns the list to Pending rather than All. "Clear" means back to the default view, and the
   * default view is deliberately the queue that needs attention.
   */
  onClearAndClose() {
    this.filter_options.status = 'pending';
    this.onSaveAndClose();
  }

  onSaveAndClose() {
    this.dialogRef.close(this.filter_options);
  }
}
